import React from "react";
import { Col, Row, Space, Typography } from "antd";


const { Text } = Typography;

const CommvaultMasterDataComponent = ({ children }) => {
  return (
    <div>
      <Row gutter={[60, 40]} justify="center">
        <Col span={20}>
          <Text strong> Commvault Site Details :</Text>
        </Col>
        <Col span={20}>
        {children}
        </Col>
      </Row>
    </div>
  );
};

export default CommvaultMasterDataComponent;
